/**
 * Task 151-B — Arabic display labels for the contract enum keys (the
 * `@kmi/contracts` package owns the keys only; labels are presentation).
 * Shared by the config sections and the package card.
 */

import type {
  AdPlatformKey,
  AdsPricingMode,
  ProductionTypeKey,
  SocialPlatformKey,
} from '@kmi/contracts';

export const SOCIAL_PLATFORM_LABELS: Readonly<Record<SocialPlatformKey, string>> = {
  instagram: 'إنستجرام',
  tiktok: 'تيك توك',
  snapchat: 'سناب شات',
  twitter: 'X (تويتر)',
  facebook: 'فيسبوك',
  youtube: 'يوتيوب',
  linkedin: 'لينكد إن',
};

export const AD_PLATFORM_LABELS: Readonly<Record<AdPlatformKey, string>> = {
  meta: 'Meta (فيسبوك/إنستجرام)',
  google: 'إعلانات قوقل',
  tiktok: 'إعلانات تيك توك',
  snapchat: 'إعلانات سناب شات',
  x: 'إعلانات X',
  linkedin: 'إعلانات لينكد إن',
};

export const PRODUCTION_TYPE_LABELS: Readonly<Record<ProductionTypeKey, string>> = {
  reels: 'ريلز',
  tiktok: 'تيك توك',
  pro_photo: 'تصوير احترافي',
  menu_photo: 'تصوير منيو / مطعم',
  opening_photo: 'تصوير افتتاح',
};

export const ADS_PRICING_LABELS: Readonly<Record<AdsPricingMode, string>> = {
  fixed: 'مبلغ ثابت',
  percentage: 'نسبة من ميزانية الإعلان',
  hybrid: 'مبلغ ثابت + نسبة',
};
